import React from 'react'

function Container({ children }) {
    return (
        <div className='max-w-[750px] lg:max-w-[1250px] mx-auto px-4'>{children}</div>
    )
}

export default Container